import React from 'react'
import classNames from 'classnames'

import EducatorsBadge from 'ui-component-library/icons/badge-educators.svg'
import KidsBadge from 'ui-component-library/icons/badge-kids.svg'
import OnlineKidsBadge from 'ui-component-library/icons/badge-online-kids.svg'
import OnlineL1Badge from 'ui-component-library/icons/badge-online-l1.svg'
import L1Badge from 'ui-component-library/icons/badge-l1.svg'
import L2Badge from 'ui-component-library/icons/badge-l2.svg'
import L3Badge from 'ui-component-library/icons/badge-l3.svg'
import L4Badge from 'ui-component-library/icons/badge-l4.svg'
import PrivateBadge from 'ui-component-library/icons/badge-private.svg'

import imgSizes from '../../../utils/imgSizes'
import ImageCaption from '../../00-Primitives/ImageCaption'
import Button from 'content-components/_Primatives/Button'
import { Props as ImageCaptionProps } from '../../00-Primitives/ImageCaption'
import type { LinkType } from 'types'
import style from './style.scss'

type BadgeLevels =
  | 'educators'
  | 'kids'
  | 'onlinekids'
  | 'onlinelevel1'
  | 'level1'
  | 'level2'
  | 'level3'
  | 'level4'
  | 'private'

export type Props = {
  badge?: BadgeLevels
  captionCard: ImageCaptionProps
  className?: string
  link: LinkType
}

CourseCertificationCard.defaultProps = {
  badge: undefined,
  className: '',
}

const iconVariants = {
  educators: <EducatorsBadge />,
  kids: <KidsBadge />,
  onlinekids: <OnlineKidsBadge />,
  onlinelevel1: <OnlineL1Badge />,
  level1: <L1Badge />,
  level2: <L2Badge />,
  level3: <L3Badge />,
  level4: <L4Badge />,
  private: <PrivateBadge />,
}

const imageSizes = imgSizes(325, 500, 600)

const renderIcon = (variant: keyof typeof iconVariants, className: string) =>
  React.cloneElement(iconVariants[variant], { className })

function CourseCertificationCard(props: Props) {
  const { badge, captionCard, className, link } = props
  const { text, url, target } = link

  return (
    <div className={classNames(style.wrapper, className)}>
      <ImageCaption
        className={style.captionCard}
        imageSizes={imageSizes}
        {...captionCard}
      />
      {badge && renderIcon(badge, style.svgBadge)}
      <Button
        className={style.button}
        target={target}
        url={url}
        variant='primaryBlue'
      >
        {text}
      </Button>
    </div>
  )
}

export default CourseCertificationCard
